import styled from 'styled-components';
import { Color, FontSize, Spacing } from '@pushwoosh/kit-constants';

export const StyledSubtitle = styled.div`
  padding: ${Spacing.S5} ${Spacing.S7};
  color: ${Color.MAIN};
  font-size: ${FontSize.REGULAR};
`;
